<template>
    <header>
        <div id="check-header" class="ext">
            <div class="int">
                <div class="col60">
                    <div class="box logo">
                        <span>La Ville</span><a href="https://www.lavillecasa.com.br" title="home"><img src="https://www.lavillecasa.com.br/arquivos/logo_lavillehouseware_2.png" style="width:180px;margin-top:-20px;margin-bottom: -15px;" alt="La Ville"></a>
                    </div>
                </div>
                <div class="col20 selo selo-1">
                    <div class="box security">
                        <img src="https://www.lavillecasa.com.br/arquivos/check-icon-seguranca.png" alt="site 100% seguro">
                        <p>Site 100% Seguro</p>
                    </div>
                </div>
                <div class="col20 selo selo-2">
                    <div class="box contact">
                        <img src="https://www.lavillecasa.com.br/arquivos/check-icon-phone.png" alt="telefone: (31) 3235 8200 - email:sac@lavillecasa.com.br ">
                        <p><span>(31)</span> 3235 8200</p>
                        <span>sac@lavillecasa.com.br</span>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>